<div class="policy-page" *ngIf="policy$ | async as policy">
  <div class="policy-container">
    <a routerLink="/" class="back-link">← Back</a>

    <h1 class="policy-title">
      {{ getTitle(policy) }}
    </h1>

    <div
      class="policy-content"
      [innerHTML]="getContentKey(policy) | translate"
    ></div>
  </div>
</div>
